export { InfoModule } from './info.module';
export { InfoComponent } from './info.component';

